export default __webpack_public_path__ + "static/media/uniswap.b2b0a895.png";